<template>
  <div class="Bingo" v-if="bingo" @click="unsetBingo()">

    <h1>
      BINGO!
    </h1>

  </div>
</template>

<script>

import { store } from '@/store';

export default {
  name: 'Bingo',
  components: {
  },
  data () {
    return {
    }
  },
  props: {
  },
  computed: {
    bingo: function () {
      return store.state.bingo;
    }
  },
  watch: {
    bingo: function () {
      this.display = true;
    }
  },
  methods: {
    unsetBingo: function () {
      //this.display = !this.display;
      store.commit('unsetBingo');
    }
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.Bingo{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: palegreen;
  animation: party 2s infinite, color 3s infinite;
  text-shadow: 10px 10px 15px black;
  font-size: 8vw;
}

@media screen and (min-width: 600px) {
  .Bingo{
    font-size: 4vw;
  }
}

@keyframes party {
  25% {
    transform: scale(1.5) rotate(-5deg);
  }
  50%{
    transform: scale(1) rotate(0deg);
  }
  75% {
    transform: scale(1.5) rotate(5deg);
  }
}

@keyframes color {
  50%{
    color: yellow;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Bingo.vue